<template>
  <div class="card-product">
    <img
      :src="item.product_image[0] || '/assets/product/default.png'"
      alt="Card-product Image"
      class="card-product-image"
    />
    <h2 class="card-product-title title-product">{{ item.product_name }}</h2>
    <div class="card-product-content">
      <!-- <p class="card-product-description">{{ description }}</p> -->
      <p class="card-product-price">
        Harga Retail:
        {{
          Number(item.product_price).toLocaleString("id-ID", {
            style: "currency",
            currency: "IDR",
            minimumFractionDigits: 0,
          })
        }}
      </p>
      <hr />
      <slot />
    </div>
    <div class="card-footer">
      <v-btn
        @click="$emit('showConfirmAdd', item)"
        color="deep-purple lighten-2"
        text class="btn-add"
      >
        Tambahkan
      </v-btn>
    </div>
  </div>
  <!-- <v-card class="mx-auto" max-width="500">
    <v-img 
      height="250"
      :src="item.product_image[0] || '/assets/product/default.png'"
    ></v-img>
    <v-card-text class="px-2 pt-1">
      <v-card-title class="title-product">{{ item.product_name }}</v-card-title>
    </v-card-text>

    <v-card-actions> 
      <div class="my-4 text-subtitle-1">
        Harga Retail:
        {{
          Number(item.product_price).toLocaleString("id-ID", {
            style: "currency",
            currency: "IDR",
            minimumFractionDigits: 0,
          })
        }}
      </div>
      <v-spacer></v-spacer>
      <v-btn title="Daftar Harga" icon @click="show = !show">
        <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
      </v-btn>
    </v-card-actions>
    <v-expand-transition>
      <div v-show="show">
        <v-divider></v-divider>
        <v-card-text>
          <slot />
        </v-card-text>
      </div>
    </v-expand-transition>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn
        @click="$emit('showConfirmAdd', item)"
        color="deep-purple lighten-2"
        text
      >
        Tambahkan
      </v-btn>
    </v-card-actions>
  </v-card> -->
</template>

<script>
export default {
  props: {
    item: Object,
  },
  data() {
    return {
      show: true,
    };
  },
};
</script>

<style lang="scss" scoped>
.card-footer { 
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.title-product {
  background: rgb(255, 241, 110);
  background: linear-gradient(
    90deg,
    rgba(255, 241, 110, 1) 25%,
    rgba(213, 164, 31, 1) 100%
  );
  font-size: 1rem;
  font-weight: 700;
  color: #000;
  border-radius: 15px;
  margin: 0 .5rem;
  padding:.5rem;
  text-align: center;
}
.card-product {
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  margin: 16px;
  width: 100%;
  height: 100%;
  transition: transform 0.2s ease-in-out;
}

// .card-product:hover {
//   transform: scale(1.05);
// }

.card-product-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.card-product-content {
  padding: 16px;
}

.card-product-title {
  font-size: 1.2rem;
  margin-bottom: 8px;
}

.card-product-description {
  color: #555;
  margin-bottom: 12px;
}

.card-product-price {
  font-weight: bold;
  color: #333;
}
</style>